export default "__VITE_ASSET__6143b7fd__"